export default __webpack_public_path__ + "static/media/8h.1f47fdcb.svg";